import React from "react";
import { useTranslation } from "@helpers/translate";
import TradeDirectionArrows from "../TradeDirectionArrows";
import "./index.sass";

export const TradeButtons = ({ onSelect, disabled = false }) => {
  const { __ } = useTranslation();

  return (
    <div className="trade-buttons">
      <button
        type="button"
        className="trade-btn trade-btn--long"
        disabled={disabled}
        onClick={() => onSelect("long")}
      >
        <TradeDirectionArrows
          direction="long"
          className="trade-btn__icon"
          size={18}
          isAnimating
        />
        {__("futures.long")}
      </button>

      <button
        type="button"
        className="trade-btn trade-btn--short"
        disabled={disabled}
        onClick={() => onSelect("short")}
      >
        <TradeDirectionArrows
          direction="short"
          className="trade-btn__icon"
          size={18}
          isAnimating
        />
        {__("futures.short")}
      </button>
    </div>
  );
};

export default TradeButtons;
